import React from "react";

const GlobalLoader = ({ fullPage = false, message = "Loading..." }) => (
  <div className={`flex items-center justify-center ${fullPage ? "min-h-screen" : "h-full w-full min-h-[400px]"}`}>
    <div className="flex flex-col items-center gap-4">
      <div className="relative">
        <div className="animate-spin rounded-full h-14 w-14 border-t-2 border-b-2 border-[#ef7925]"></div>
        <div className="absolute inset-0 flex items-center justify-center">
           <div className="h-2 w-2 bg-[#ef7925] rounded-full"></div>
        </div>
      </div>
      {message && <p className="text-[#ef7925] text-sm font-medium animate-pulse tracking-wide uppercase">{message}</p>}
    </div>
  </div>
);

export default GlobalLoader;
